import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Coffee, SignOut, ChartBar, House, User } from '@phosphor-icons/react';

export default function Navbar({ variant = 'default' }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <nav className="border-b-2 border-foreground bg-background sticky top-0 z-40 grainy" data-testid="main-navbar">
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-18 flex items-center justify-between">
        <Link to="/" className="flex items-center group" data-testid="nav-logo">
          <img src="/logo-header.png" alt="Traktirkan" className="h-12 w-auto object-contain" />
        </Link>
        <div className="flex items-center gap-2 md:gap-3">
          {user ? (
            <>
              {user.is_admin && (
                <Link
                  to="/admin"
                  className="hidden md:inline-flex items-center gap-1.5 border-2 border-foreground bg-foreground text-background px-3 py-2 text-xs font-bold uppercase tracking-wide shadow-brutal-sm hover:shadow-none hover:translate-x-[2px] hover:translate-y-[2px] transition-all"
                  data-testid="nav-admin-btn"
                >
                  Admin
                </Link>
              )}
              <Link
                to={`/u/${user.username}`}
                className="hidden sm:inline-flex text-sm font-medium px-3 py-2 hover:underline underline-offset-4"
                data-testid="nav-my-profile"
              >
                @{user.username}
              </Link>
              <Link
                to="/dashboard"
                className="inline-flex items-center gap-2 border-2 border-foreground bg-accent px-3 md:px-4 py-2 text-sm font-bold uppercase tracking-wide shadow-brutal-sm hover:shadow-none hover:translate-x-[2px] hover:translate-y-[2px] transition-all"
                data-testid="nav-dashboard-btn"
              >
                <ChartBar size={16} weight="bold" />
                <span className="hidden sm:inline">Dashboard</span>
              </Link>
              <button
                onClick={handleLogout}
                className="inline-flex items-center gap-2 border-2 border-foreground bg-white px-3 py-2 text-sm font-bold uppercase tracking-wide shadow-brutal-sm hover:shadow-none hover:translate-x-[2px] hover:translate-y-[2px] transition-all"
                data-testid="nav-logout-btn"
              >
                <SignOut size={16} weight="bold" />
                <span className="hidden sm:inline">Keluar</span>
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                className="px-3 md:px-4 py-2 text-sm font-bold hover:underline underline-offset-4"
                data-testid="nav-login-btn"
              >
                Masuk
              </Link>
              <Link
                to="/register"
                className="inline-flex items-center gap-2 border-2 border-foreground bg-primary text-white px-3 md:px-4 py-2 text-sm font-bold uppercase tracking-wide shadow-brutal-sm hover:shadow-none hover:translate-x-[2px] hover:translate-y-[2px] transition-all"
                data-testid="nav-register-btn"
              >
                Mulai Gratis
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
